import api from './api.js'

// Sync Service
export const syncService = {
  async getProgress(type = null) {
    const params = type ? { type } : {}
    const response = await api.get('/sync/progress', { params })
    return response.data
  },

  async forceUnlock() {
    const response = await api.post('/sync/force-unlock')
    return response.data
  },

  async getLastSynced() {
    const response = await api.get('/sync/last-synced')
    return response.data.success ? response.data.data : {}
  }
}
